import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const ContractTypeSelectionModal = ({ isOpen, onClose, onSelectType }) => {
  const [selectedType, setSelectedType] = useState(null);
  const [feeType, setFeeType] = useState('percentage');
  const [feeValue, setFeeValue] = useState('');

  if (!isOpen) return null;

  const contractTypes = [
    {
      id: 'rent',
      icon: 'Home',
      label: 'عقد إيجار',
      description: 'عقد إيجار سكني أو تجاري',
      color: '#3B82F6',
      defaultFeeType: 'percentage',
      defaultFeeValue: '5'
    },
    {
      id: 'buying',
      icon: 'ShoppingCart',
      label: 'عقد شراء',
      description: 'عقد شراء عقار',
      color: '#10B981',
      defaultFeeType: 'percentage',
      defaultFeeValue: '2.5'
    },
    {
      id: 'selling',
      icon: 'TrendingUp',
      label: 'عقد بيع',
      description: 'عقد بيع عقار',
      color: '#F59E0B',
      defaultFeeType: 'percentage',
      defaultFeeValue: '2.5'
    },
    {
      id: 'marketing',
      icon: 'Megaphone',
      label: 'عقد تسويق عقاري',
      description: 'عقد تسويق وترويج عقار',
      color: '#8B5CF6',
      defaultFeeType: 'percentage',
      defaultFeeValue: '3'
    },
    {
      id: 'client_representation',
      icon: 'Users',
      label: 'عقد تمثيل عميل',
      description: 'عقد تمثيل العميل في المعاملات',
      color: '#EC4899',
      defaultFeeType: 'percentage',
      defaultFeeValue: '2'
    },
    {
      id: 'property_management',
      icon: 'Building',
      label: 'عقد إدارة عقارات',
      description: 'عقد إدارة وصيانة عقار',
      color: '#06B6D4',
      defaultFeeType: 'percentage',
      defaultFeeValue: '8'
    },
    {
      id: 'lease_to_own',
      icon: 'Key',
      label: 'عقد إيجار منتهي بالتملك',
      description: 'عقد إيجار مع خيار الشراء',
      color: '#14B8A6',
      defaultFeeType: 'percentage',
      defaultFeeValue: '4'
    },
    {
      id: 'joint_venture',
      icon: 'Handshake',
      label: 'عقد مشاركة عقارية',
      description: 'عقد شراكة في مشروع عقاري',
      color: '#F97316',
      defaultFeeType: 'percentage',
      defaultFeeValue: '3.5'
    },
    {
      id: 'development',
      icon: 'Construction',
      label: 'عقد تطوير عقاري',
      description: 'عقد تطوير وبناء مشروع',
      color: '#EF4444',
      defaultFeeType: 'percentage',
      defaultFeeValue: '5'
    },
    {
      id: 'consultation',
      icon: 'MessageSquare',
      label: 'عقد استشارات عقارية',
      description: 'عقد تقديم استشارات عقارية',
      color: '#6366F1',
      defaultFeeType: 'fixed',
      defaultFeeValue: '1000'
    },
    {
      id: 'valuation',
      icon: 'Calculator',
      label: 'عقد تقييم عقاري',
      description: 'عقد تقييم قيمة العقار',
      color: '#8B5CF6',
      defaultFeeType: 'fixed',
      defaultFeeValue: '500'
    },
    {
      id: 'brokerage',
      icon: 'Briefcase',
      label: 'عقد وساطة عقارية',
      description: 'عقد وساطة بين البائع والمشتري',
      color: '#A855F7',
      defaultFeeType: 'percentage',
      defaultFeeValue: '2'
    },
    {
      id: 'maintenance',
      icon: 'Wrench',
      label: 'عقد صيانة عقار',
      description: 'عقد صيانة دورية للعقار',
      color: '#84CC16',
      defaultFeeType: 'fixed',
      defaultFeeValue: '300'
    },
    {
      id: 'commercial_lease',
      icon: 'Store',
      label: 'عقد إيجار تجاري',
      description: 'عقد إيجار محل أو مكتب تجاري',
      color: '#0EA5E9',
      defaultFeeType: 'percentage',
      defaultFeeValue: '6'
    },
    {
      id: 'land_sale',
      icon: 'Map',
      label: 'عقد بيع أرض',
      description: 'عقد بيع قطعة أرض',
      color: '#22C55E',
      defaultFeeType: 'percentage',
      defaultFeeValue: '2'
    },
    {
      id: 'investment',
      icon: 'TrendingUp',
      label: 'عقد استثمار عقاري',
      description: 'عقد استثمار في مشروع عقاري',
      color: '#F59E0B',
      defaultFeeType: 'percentage',
      defaultFeeValue: '4'
    },
    {
      id: 'mortgage',
      icon: 'CreditCard',
      label: 'عقد رهن عقاري',
      description: 'عقد رهن عقار لضمان قرض',
      color: '#DC2626',
      defaultFeeType: 'percentage',
      defaultFeeValue: '1.5'
    },
    {
      id: 'sublease',
      icon: 'Repeat',
      label: 'عقد إيجار من الباطن',
      description: 'عقد تأجير عقار مستأجر',
      color: '#7C3AED',
      defaultFeeType: 'percentage',
      defaultFeeValue: '4'
    },
    {
      id: 'exchange',
      icon: 'ArrowLeftRight',
      label: 'عقد مقايضة عقارية',
      description: 'عقد تبادل عقارات',
      color: '#059669',
      defaultFeeType: 'percentage',
      defaultFeeValue: '3'
    },
    {
      id: 'auction',
      icon: 'Gavel',
      label: 'عقد بيع بالمزاد',
      description: 'عقد بيع عقار عن طريق المزاد',
      color: '#DB2777',
      defaultFeeType: 'percentage',
      defaultFeeValue: '5'
    }
  ];

  const handleTypeSelect = (type) => {
    setSelectedType(type);
    setFeeType(type?.defaultFeeType || 'percentage');
    setFeeValue(type?.defaultFeeValue || '');
  };

  const handleContinue = () => {
    if (!selectedType || !feeValue) {
      alert('الرجاء اختيار نوع العقد وتحديد الرسوم');
      return;
    }

    onSelectType({
      type: selectedType,
      feeType,
      feeValue: parseFloat(feeValue)
    });
    onClose();
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10002]" onClick={onClose} />
      <div 
        className="fixed z-[10003] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto custom-scrollbar"
        style={{
          borderColor: '#8B5CF6',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div className="p-6" dir="rtl">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-purple-600/20 rounded-lg">
                <Icon name="FileText" size={24} color="#8B5CF6" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">اختر نوع العقد</h3>
                <p className="text-sm text-gray-400">حدد نوع العقد والرسوم المطلوبة</p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          {/* Contract Type Selection */}
          <div className="mb-6">
            <h4 className="text-white font-semibold mb-4 text-right">نوع العقد</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 max-h-[400px] overflow-y-auto custom-scrollbar pr-2">
              {contractTypes?.map((type) => (
                <div
                  key={type?.id}
                  onClick={() => handleTypeSelect(type)}
                  className={`p-4 rounded-xl border-2 cursor-pointer transition-all hover:scale-105 ${
                    selectedType?.id === type?.id
                      ? 'border-purple-500 bg-purple-600/20' :'border-gray-700 bg-gray-800/50 hover:border-gray-600'
                  }`}
                >
                  <div className="flex items-start gap-3">
                    <div 
                      className="p-2 rounded-lg"
                      style={{ backgroundColor: `${type?.color}20` }}
                    >
                      <Icon name={type?.icon} size={24} color={type?.color} />
                    </div>
                    <div className="flex-1">
                      <h5 className="text-white font-semibold mb-1">{type?.label}</h5>
                      <p className="text-sm text-gray-400">{type?.description}</p>
                    </div>
                    {selectedType?.id === type?.id && (
                      <Icon name="CheckCircle" size={20} color="#8B5CF6" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Fee Configuration */}
          {selectedType && (
            <div className="bg-gray-800/50 rounded-xl p-5 border border-gray-700">
              <h4 className="text-white font-semibold mb-4 text-right flex items-center gap-2">
                <Icon name="DollarSign" size={20} color="#8B5CF6" />
                إعدادات الرسوم والعمولة
              </h4>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Fee Type */}
                <div>
                  <label className="text-white font-medium mb-2 block text-right">نوع الرسوم</label>
                  <select
                    value={feeType}
                    onChange={(e) => setFeeType(e?.target?.value)}
                    className="w-full bg-gray-900/50 border border-gray-700 rounded-lg p-3 text-white text-right"
                    dir="rtl"
                  >
                    <option value="percentage">نسبة مئوية (%)</option>
                    <option value="fixed">مبلغ ثابت (دينار أردني)</option>
                  </select>
                </div>

                {/* Fee Value */}
                <div>
                  <label className="text-white font-medium mb-2 block text-right">
                    {feeType === 'percentage' ? 'النسبة المئوية' : 'المبلغ الثابت'}
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      value={feeValue}
                      onChange={(e) => setFeeValue(e?.target?.value)}
                      placeholder={feeType === 'percentage' ? 'مثال: 5' : 'مثال: 5000'}
                      className="w-full bg-gray-900/50 border border-gray-700 rounded-lg p-3 text-white text-right pr-12"
                      dir="rtl"
                      step={feeType === 'percentage' ? '0.1' : '100'}
                      min="0"
                    />
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                      {feeType === 'percentage' ? '%' : 'JOD'}
                    </span>
                  </div>
                </div>
              </div>

              {/* Fee Preview */}
              {feeValue && (
                <div className="mt-4 p-3 bg-purple-600/10 border border-purple-500/30 rounded-lg">
                  <div className="flex items-center gap-2 text-purple-300 text-sm">
                    <Icon name="Info" size={16} color="#A78BFA" />
                    <span>
                      {feeType === 'percentage'
                        ? `سيتم احتساب ${feeValue}% من قيمة العقد كرسوم`
                        : `رسوم ثابتة بقيمة ${feeValue} دينار أردني`}
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex gap-3 mt-6">
            <button
              onClick={handleContinue}
              disabled={!selectedType || !feeValue}
              className="flex-1 py-3 rounded-lg font-semibold text-white bg-purple-600 hover:bg-purple-700 transition-colors flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <Icon name="ArrowRight" size={18} color="#FFF" />
              متابعة
            </button>
            <button
              onClick={onClose}
              className="flex-1 py-3 rounded-lg font-semibold text-white bg-gray-700 hover:bg-gray-600 transition-colors"
            >
              إلغاء
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(139, 92, 246, 0.1);
          border-radius: 4px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #8B5CF6;
          border-radius: 4px;
        }
        
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #7C3AED;
        }
      `}</style>
    </>
  );
};

export default ContractTypeSelectionModal;